var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStoreLightSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.6,
    height: 41.6,
    rx: 8,
    transform: "matrix(1.25 0 0 -1.25 0 52)",
    fill: "#DCE3E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2774 27.0551C35.2387 22.8652 38.7961 20.8268 38.9587 20.7319C36.9441 17.868 33.8214 17.4767 32.7241 17.4455C30.1014 17.1764 27.5574 18.9756 26.2214 18.9756C24.8587 18.9756 22.8014 17.4715 20.5841 17.5157C17.7307 17.5586 15.0614 19.1693 13.5974 21.6705C10.5761 26.7704 12.8294 34.2649 15.7241 38.3872C17.1721 40.4061 18.8641 42.6603 21.0787 42.581C23.2454 42.4939 24.0547 41.2342 26.6694 41.2342C29.2601 41.2342 30.0201 42.581 32.2787 42.5303C34.6041 42.4939 36.0681 40.5023 37.4654 38.4652C39.1387 36.1512 39.8107 33.8723 39.8374 33.7553C39.7827 33.7371 35.3214 32.077 35.2774 27.0551Z",
    fill: "#030304"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0107 14.7337C32.1761 13.3128 32.9734 11.3797 32.7521 9.41797C31.0654 9.49077 28.9561 10.5555 27.7414 11.9452C26.6667 13.1698 25.7067 15.177 25.9547 17.0646C27.8494 17.2024 29.7947 16.1325 31.0107 14.7337Z",
    fill: "#030304"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreLightSquare);
export default __webpack_public_path__ + "static/media/app_store_light_square.c2e97237e330acb9fdc1ab46f143da78.svg";
export { ForwardRef as ReactComponent };